import React from "react";
import { NavLink, Switch, Route, Redirect } from "react-router-dom";
import Exchange from "./Exchange";
import Liquidity from "./Liquidity";
import RiskTokenPools from "./RiskTokenPools";

export default function () {
  return (
    <div className="swap">
      <div className="swap_header_wrapper">
        <header className="swap-header">
          <NavLink to="/swap" className="swap-header__btn" exact>
            Exchange
            <div className="swap_line"></div>
          </NavLink>
          <NavLink to="/swap/risk-token-pools" className="swap-header__btn">
            Risk Token Pools
            <div className="swap_line"></div>
          </NavLink>
          <NavLink to="/swap/liquidity" className="swap-header__btn">
            Liquidity
            <div className="swap_line"></div>
          </NavLink>
          <div className="swap_line_header"></div>
        </header>
      </div>
      <Switch>
        <Route path="/swap" component={Exchange} exact />
        <Route path="/swap/risk-token-pools" component={RiskTokenPools} />
        <Route path="/swap/liquidity" component={Liquidity} />
        <Redirect to="/swap" />
      </Switch>
    </div>
  );
}
